import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { installFilterDatePickerAutoOpen } from './utils/nativeDatePicker'
import './styles/admin-shared.css'
import './styles/admin-list-page.css'

installFilterDatePickerAutoOpen()

createApp(App).use(router).mount('#app')
